<template>
  <div class="bq-page" :class="{ mobile: isMobile }">
    <banner
      :cover="banner.cover"
      :mcover="banner.mcover"
      :title="banner.title"
    />

    <!-- 列表模式 -->
    <box class="bq-box" title="新闻动态" v-show="mode === 'list'">
      <card
        class="bq-box-item"
        layout="horizontal"
        size="middle"
        v-for="(item, index) in newsData.news"
        :key="index"
        :cover="item.cover"
        :title="item.title"
        @click.native="showLists(index)"
      >
        <p class="bq-box-item-tag" slot="tag">{{ item.time }}</p>
        <p class="bq-box-item-content" slot="content">{{ item.desc }}</p>
      </card>
    </box>

    <!-- 详情模式 -->
    <div class="mode-lists" v-if="mode === 'detail'">
      <tab
        class="tabs"
        :tabs="newsData.news"
        :default-active="listsIndex"
        :clickCallback="handleTabClick"
      />
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import Box from '@/components/Box';
import Card from '@/components/Card';
import Tab from '@/components/Tab';

import { banner, newsData } from './news.js';
import { isWirelessDevice } from '../../../utils/utils.js';

export default {
  name: 'news',

  components: {
    Banner,
    Box,
    Card,
    Tab,
  },

  data() {
    const { query } = this.$route;

    return {
      isMobile: false,
      mode: query.post ? 'detail' : 'list',
      listsIndex: query.post ? Number(query.post) - 1 : 0,
      banner,
      newsData,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    showLists(index) {
      this.mode = 'detail';
      this.listsIndex = index;

      if (this.isMobile) {
        return;
      }

      // 500 是刚好让tab组件处于一个页面的可视区域中间的位置
      document.body.scrollTop = document.documentElement.scrollTop = 500;
    },

    handleTabClick(item) {
      // this.$router.push(item.path);
      location.href = item.path;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
